import React, { useState } from "react";
import { useTranslation } from "react-i18next";

type JourneyWhyKey =
  | "JourneyGuide_Assets_Why_Summary"
  | "JourneyGuide_Assets_Why_Detail"
  | "JourneyGuide_People_Why_Summary"
  | "JourneyGuide_People_Why_Detail"
  | "JourneyGuide_Leases_Why_Summary"
  | "JourneyGuide_Leases_Why_Detail"
  | "JourneyGuide_Money_Why_Summary"
  | "JourneyGuide_Money_Why_Detail"
  | "JourneyGuide_Ops_Why_Summary"
  | "JourneyGuide_Ops_Why_Detail"
  | "JourneyGuide_Team_Why_Summary"
  | "JourneyGuide_Team_Why_Detail";

interface JourneyWhyExpanderProps {
  summaryKey: JourneyWhyKey;
  detailKey: JourneyWhyKey;
}

/**
 * Progressive disclosure — headline always visible; detail expands on click.
 * Touch target is at least 44px for mobile.
 */
export const JourneyWhyExpander: React.FC<JourneyWhyExpanderProps> = ({
  summaryKey,
  detailKey,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className={`journey-why${open ? " is-open" : ""}`}>
      <button
        type="button"
        className="journey-why-toggle"
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span>{t(summaryKey)}</span>
        <span className="journey-why-chevron" aria-hidden>
          {open ? "−" : "+"}
        </span>
      </button>
      {open && <p className="journey-why-detail">{t(detailKey)}</p>}
    </div>
  );
};
